/** Get the embedding URL Params for the embeddable frontend */

// params
const params = new URLSearchParams(window.location.search);

// get apiKey from url params
export const apiKeyUrlParam = function(): string|null {
	// also allow lower case version
	return params.get('apiKey') ? params.get('apiKey') : params.get('apikey');
}

// get language from url params
export const languageUrlParam = function(): string|null {
	// also allow short version
	return params.get('language') ? params.get('language') : params.get('lang');
}

// get page from url params
export const pageUrlParam = function(): string|null {
	return params.get('page');
}

// get parameter from url params
export const parameterUrlParam = function(): string {
	return params.get('parameter') ? params.get('parameter')! : '';
}

// get documentToken from url params, used to authenticate embedded single-document views
export const documentTokenUrlParam = function(): string|null {
	return params.get('documentToken');
}

// whether the view is embedded, which drops the app chrome (navbar and layout margin).
// Combine with "view" to select a specific chromeless sub-view, e.g. view=documentSplit.
export const embeddedUrlParam = function(): boolean {
	return params.get('embedded') === 'true';
}

// get view from url params, used to select which sub-view to show in an embedded context
export const viewUrlParam = function(): string|null {
	return params.get('view');
}
